import { isSupportedCountry } from 'libphonenumber-js/min';

import type { CountryCode } from 'libphonenumber-js/min';

const DEFAULT_COUNTRY: CountryCode = 'AE';

/** Regional-indicator pair, rendered as a flag where the font supports it. */
export function flagEmoji(country: string): string {
  return String.fromCodePoint(
    ...country
      .toUpperCase()
      .split('')
      .map((character) => 0x1f1a5 + character.charCodeAt(0))
  );
}

/** Intl supplies localized country names without shipping a translation table. */
export function countryName(country: string, locale?: string): string {
  try {
    return (
      new Intl.DisplayNames([locale ?? navigator.language], { type: 'region' }).of(country) ??
      country
    );
  } catch {
    return country;
  }
}

export function browserCountry(): CountryCode {
  try {
    const { region } = new Intl.Locale(navigator.language).maximize();
    if (region && isSupportedCountry(region)) return region;
  } catch {
    // Older browsers or malformed locale tags use the default.
  }
  return DEFAULT_COUNTRY;
}
